<form #thisForm="ngForm" (ngSubmit)="submit()">
  <app-dados-boleta
    titulo="Dados da Boleta - Passivo"
    [operationDate]="model.operationDate"
    [id]="model.id"
    [accountManagerName]="model.accountManagerName"
    [accountManagerDocument]="model.accountManagerDocument"
    [statusDescription]="model.statusDescription"
  >
  </app-dados-boleta>

  <div class="row">
    <div class="col-md-6 col-12">
      <div class="card mt-3">
        <div class="card-header text-uppercase">Tipo de Liquidação</div>
        <div class="card-body">
          <div class="col-12">
            <div
              class="form-check form-check-inline"
              *ngFor="let item of ListSettlementTypes; index as i"
            >
              <input
                class="form-check-input"
                data-cy="settlementTypeId"
                type="radio"
                name="settlementTypeId"
                id="{{ 'tm-' + i + '-id' }}"
                [value]="item.id"
                [(ngModel)]="model.settlementTypeId"
              />
              <label class="form-check-label" for="{{ 'tm-' + i + '-id' }}">
                {{ item.name }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-12">
      <div class="card mt-3">
        <div class="card-header text-uppercase">Tipo de Operação</div>
        <div class="card-body">
          <div class="col-12">
            <div *ngIf="isCETIP() || isTED()">
              <div
                class="form-check form-check-inline"
                *ngFor="let item of ListOperationTypesLiabilities; index as i"
              >
                <input
                  class="form-check-input"
                  data-cy="operationTypeId"
                  type="radio"
                  name="operationTypeId"
                  id="{{ 'operationType-' + i + '-id' }}"
                  [value]="item.id"
                  [(ngModel)]="model.operationTypeId"
                />

                <label
                  class="form-check-label"
                  for="{{ 'operationType-' + i + '-id' }}"
                >
                  {{ item.name }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card mt-3">
    <div class="card-header text-uppercase">Dados do Cotista</div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-3">
          <label for="isNewShareholder">Novo cotista</label>
          <div>
            <div class="form-check form-check-inline">
              <input
                data-cy="isNewShareholder"
                class="form-check-input"
                id="isNewShareholder"
                name="isNewShareholder"
                [(ngModel)]="model.isNewShareholder"
                type="checkbox"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-2" *ngIf="model.isNewShareholder === false">
        <div [ngClass]="viewStockButton() ? 'col-10' : 'col-12'">
          <div [class.has-error]="hasError('portfolioName')">
            <label>Nome do Cotista</label>
            <ng-select
              notFoundText="Cotista não encontrado"
              typeToSearchText="Digite o nome do cotista para pesquisar..."
              [selectOnTab]="true"
              [(ngModel)]="selectedShareholder"
              [ngModelOptions]="{ standalone: true }"
              [typeahead]="shareholderSearchNameTerm"
              [items]="shareholdersByName | async"
              [clearable]="false"
              bindLabel="name"
              [disabled]="shareholderNameIsDisabled"
              (change)="fillShareholderSelected()"
            >
              <ng-template ng-label-tmp let-item="item">
                {{ item.name }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                {{ item.document }} {{ item.name }} (CÓD: {{ item.sourceId }})
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="col-2" *ngIf="viewStockButton()">
          <input
            type="button"
            value="Visualizar Estoque"
            class="btn btn-primary me-2"
            style="margin-top: 22px; width: 100%"
            appDebounceClick
            (debounceClick)="openStockFundsDialog()"
            [debounceTime]="200"
            [disabled]="selectedShareholder.sourceId == null"
          />
        </div>
      </div>
      <div class="row mb-2" *ngIf="model.isNewShareholder">
        <div class="col-12" [class.has-error]="hasError('portfolioName')">
          <label>Nome do Cotista</label>
          <input
            type="text"
            data-cy="portfolioName"
            class="form-control"
            name="portfolioName"
            [(ngModel)]="model.portfolioName"
            maxlength="90"
            required
            pattern="^(?!\s*$).+"
            [disabled]="shareholderIsDisabled"
          />
        </div>
      </div>

      <div class="row mb-2">
        <div
          *ngIf="model.isNewShareholder === false"
          class="col-3"
          [class.has-error]="hasError('portfolioDocument')"
        >
          <label>CPF/CNPJ do Cotista</label>
          <ng-select
            notFoundText="Cotista não encontrado"
            typeToSearchText="Digite o CPF/CNPJ do cotista para pesquisar..."
            [selectOnTab]="true"
            [(ngModel)]="selectedShareholder"
            [ngModelOptions]="{ standalone: true }"
            [typeahead]="shareholderSearchDocumentTerm"
            [items]="shareholdersByDocument | async"
            [clearable]="false"
            bindLabel="document"
            (change)="fillShareholderSelected()"
          >
            <ng-template ng-label-tmp let-item="item">
              {{ item.document }}
            </ng-template>

            <ng-template ng-option-tmp let-item="item">
              {{ item.document }} {{ item.name }}
            </ng-template>
          </ng-select>
        </div>
        <div
          *ngIf="model.isNewShareholder"
          class="col-3"
          [class.has-error]="hasError('portfolioDocument')"
        >
          <label>CPF/CNPJ do Cotista</label>
          <input
            data-cy="portfolioDocument"
            type="text"
            class="form-control"
            name="portfolioDocument"
            [(ngModel)]="model.portfolioDocument"
          />
        </div>
        <div
          class="col-9"
          *ngIf="
            model.isNewShareholder === false && model.shareholderHasAccount
          "
          [class.has-error]="hasError('portfolioBank')"
        >
          <label>Dados Bancários</label>
          <ng-select
            notFoundText="Banco, Agência ou Conta Corrente não encontradas"
            typeToSearchText="Digite Banco, Agência ou Conta Corrente"
            [selectOnTab]="true"
            (change)="fillComponentWhenShareholderAccountSelected()"
            [(ngModel)]="selectedShareholderAccount"
            [ngModelOptions]="{ standalone: true }"
            [items]="shareholderAccountList"
            [clearable]="false"
            [disabled]="false"
          >
            <ng-template
              ng-label-tmp
              let-item="item"
              *ngIf="selectedShareholderAccount !== null"
            >
              Banco: {{ item.bank }}&nbsp;&nbsp;&nbsp;&nbsp;Agência:
              {{ item.branch }}&nbsp;&nbsp;&nbsp;&nbsp;Conta Corrente:
              {{ item.account }}
            </ng-template>
            <ng-template ng-header-tmp *ngIf="shareholderAccountList !== null">
              <div class="row mb-2">
                <div class="col-4">Banco</div>
                <div class="col-4">Agência</div>
                <div class="col-4">Conta</div>
              </div>
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              <div class="row mb-2">
                <div class="col-4">{{ item.bank }}</div>
                <div class="col-4">{{ item.branch }}</div>
                <div class="col-4">{{ item.account }}</div>
              </div>
            </ng-template>
          </ng-select>
        </div>
        <div
          *ngIf="model.isNewShareholder || !model.shareholderHasAccount"
          class="col-3"
          [class.has-error]="hasError('portfolioBank')"
        >
          <label>Banco do Cotista</label>
          <mat-select
            required
            data-cy="banksList"
            class="form-control"
            name="portfolioBank"
            [(value)]="model.portfolioBank"
          >
            <mat-option *ngFor="let item of banksList" [value]="item.code">
              {{ item.code + " " + item.name }}
            </mat-option>
          </mat-select>
        </div>
        <div
          *ngIf="model.isNewShareholder || !model.shareholderHasAccount"
          class="col-3"
          [class.has-error]="hasError('portfolioBranch')"
        >
          <label>Agência do Cotista</label>
          <input
            data-cy="portfolioBranch"
            type="text"
            class="form-control"
            name="portfolioBranch"
            [(ngModel)]="model.portfolioBranch"
          />
        </div>
        <div
          *ngIf="model.isNewShareholder || !model.shareholderHasAccount"
          class="col-3"
          [class.has-error]="hasError('portfolioAccount')"
        >
          <label>Conta do Cotista</label>
          <input
            data-cy="portfolioAccount"
            type="text"
            class="form-control"
            name="portfolioAccount"
            [(ngModel)]="model.portfolioAccount"
          />
        </div>
        <div *ngIf="isCETIP()" class="col-3">
          <label>Conta CETIP do Cotista</label>
          <input
            data-cy="portfolioCetipAccount"
            type="text"
            class="form-control"
            name="portfolioCetipAccount"
            [(ngModel)]="model.portfolioCetipAccount"
            pattern="\w+-?\w*"
            maxlength="15"
            [readonly]="!isCETIP()"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="card mt-3">
    <div class="card-header text-uppercase">Dados da Operação</div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-3" *ngIf="isNoFinancial()">
          <label for="subscriptionDate">Data de Subscrição </label>
          <div class="form-check form-check-inline">
            <input
              type="text"
              class="form-control"
              data-cy="subscriptionDate"
              name="subscriptionDate"
              [(ngModel)]="model.subscriptionDate"
              [textMask]="{ mask: validator.dateMask, guide: false }"
              [required]="isNoFinancial()"
            />
          </div>
        </div>

        <app-out-custody></app-out-custody>
      </div>

      <div class="row mb-2">
        <div
          *ngIf="isCETIP() || isTED()"
          class="col-4"
          [class.has-error]="hasError('operationValue')"
        >
          <label
            >Valor da Operação
            <fa-icon
              *ngIf="isRescue()"
              [icon]="faInfoCircle"
              title="Os valores de resgate poderão sofrer alterações por conta do calculo da cota do fundo."
            ></fa-icon>
          </label>
          <input
            type="text"
            data-cy="operationValueMask"
            class="form-control"
            name="operationValue"
            [(ngModel)]="model.operationValue"
            [textMask]="{ mask: validator.currencyMaskDoubleDecimal }"
            [required]="isOperationValueRequired()"
            [class.ng-invalid]="hasError('operationValue')"
          />
        </div>
        <div
          class="col-4"
          *ngIf="(isCETIP() || isTED()) && model.isSecondaryMarket"
        >
          <label>Valor da Cota</label>
          <input
            type="text"
            data-cy="quotaValue"
            class="form-control"
            name="quotaValue"
            [(ngModel)]="model.quotaValue"
            [textMask]="{ mask: validator.unitPriceMask }"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="card mt-3">
    <div class="card-header text-uppercase">Dados do Fundo Investido</div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-3" *ngIf="isCETIP() || isTED()">
          <label for="isNewFund">Novo fundo</label>
          <div>
            <div class="form-check form-check-inline">
              <input
                data-cy="isNewFund"
                class="form-check-input"
                id="isNewFund"
                name="isNewFund"
                [(ngModel)]="model.isNewFund"
                (change)="cleanAcquiredFunds()"
                [disabled]="newFundIsDisabled"
                type="checkbox"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div
          *ngIf="model.isNewFund === false"
          class="col-4"
          [class.has-error]="hasError('fundDocument')"
        >
          <label>CNPJ do Fundo Investido</label>
          <ng-select
            notFoundText="Fundo investido não encontrado"
            typeToSearchText="Digite o CNPJ do fundo investido para pesquisar..."
            [selectOnTab]="true"
            [(ngModel)]="selectedAcquiredFund"
            [ngModelOptions]="{ standalone: true }"
            [typeahead]="acquiredFundSearchDocumentTerm"
            [items]="acquiredFundsByDocument | async"
            [clearable]="false"
            bindLabel="document"
            [disabled]="acquiredFundDocumentIsDisabled"
            (change)="fillAcquiredFundSelected()"
          >
            <ng-template ng-label-tmp let-item="item">
              {{ item.document }}
            </ng-template>

            <ng-template ng-option-tmp let-item="item">
              {{ item.document }} {{ item.name }}
            </ng-template>
          </ng-select>
        </div>
        <div *ngIf="model.isNewFund" class="col-4">
          <label>CNPJ do Fundo Investido</label>
          <input
            data-cy="fundDocument"
            type="text"
            class="form-control"
            name="fundDocument"
            [(ngModel)]="model.fundDocument"
            [textMask]="{
              mask: validator.documentLegalPersonMask,
              guide: false
            }"
            pattern="\d{2}[.]\d{3}[.]\d{3}\/\d{4}-\d{2}"
            [disabled]="acquiredFundDocumentIsDisabled"
          />
        </div>
        <div class="col-8" *ngIf="isTED() && counterpartDisable()">
          <label>Dados Bancários</label>
          <ng-select
            notFoundText="Banco, Agência ou Conta Corrente não encontradas"
            typeToSearchText="Digite Banco, Agência ou Conta Corrente"
            [selectOnTab]="true"
            (change)="fillComponentWhenAcquiredFundAccountSelected()"
            [(ngModel)]="selectedAcquiredFundAccount"
            [ngModelOptions]="{ standalone: true }"
            [items]="acquiredFundAccountList"
            [clearable]="false"
            [disabled]="false"
          >
            <ng-template
              ng-label-tmp
              let-item="item"
              *ngIf="selectedAcquiredFundAccount !== null"
            >
              Banco: {{ item.bank }}&nbsp;&nbsp;&nbsp;&nbsp;Agência:
              {{ item.branch }}&nbsp;&nbsp;&nbsp;&nbsp;Conta Corrente:
              {{ item.account }}
            </ng-template>
            <ng-template ng-header-tmp *ngIf="acquiredFundAccountList !== null">
              <div class="row mb-2">
                <div class="col-4">Banco</div>
                <div class="col-4">Agência</div>
                <div class="col-4">Conta</div>
              </div>
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              <div class="row mb-2">
                <div class="col-4">{{ item.bank }}</div>
                <div class="col-4">{{ item.branch }}</div>
                <div class="col-4">{{ item.account }}</div>
              </div>
            </ng-template>
          </ng-select>
        </div>
      </div>

      <div class="row mb-2" *ngIf="model.isNewFund === false">
        <div class="col-12" [class.has-error]="hasError('fundName')">
          <label>Nome do Fundo Investido</label>
          <ng-select
            notFoundText="Fundo investido não encontrado"
            typeToSearchText="Digite o nome do fundo investido para pesquisar..."
            [selectOnTab]="true"
            [(ngModel)]="selectedAcquiredFund"
            [ngModelOptions]="{ standalone: true }"
            [typeahead]="acquiredFundSearchNameTerm"
            [items]="acquiredFundsByName | async"
            [clearable]="false"
            bindLabel="name"
            [disabled]="acquiredFundNameIsDisabled"
            (change)="fillAcquiredFundSelected()"
          >
            <ng-template ng-label-tmp let-item="item">
              {{ item.name }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              {{ item.document }} {{ item.name }} (CÓD: {{ item.sourceId }})
            </ng-template>
          </ng-select>
        </div>
      </div>

      <div class="row mb-2" *ngIf="model.isNewFund">
        <div class="col-12">
          <label>Nome do Fundo Investido</label>
          <input
            type="text"
            data-cy="fundName"
            class="form-control"
            name="fundName"
            [(ngModel)]="model.fundName"
            maxlength="90"
            required
            pattern="^(?!\s*$).+"
            [disabled]="acquiredFundDocumentIsDisabled"
          />
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-6" *ngIf="model.isNewFund">
          <label for="fundAdministrator"
            >Nome do Administrador do Fundo Investido</label
          >
          <input
            data-cy="fundAdministrator"
            type="text"
            class="form-control"
            id="fundAdministrator"
            name="fundAdministrator"
            [(ngModel)]="model.fundAdministrator"
            maxlength="90"
            required
            pattern="^(?!\s*$).+"
          />
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-3" [class.has-error]="hasError('quotationDate')">
          <label>Data de Cotização</label>
          <input
            type="text"
            class="form-control"
            data-cy="quotationDate"
            name="quotationDate"
            [(ngModel)]="model.quotationDate"
            [textMask]="{ mask: validator.dateMask, guide: false }"
            [required]="model.isNewFund"
            [readonly]="quotationDateIsDisabled"
          />
        </div>

        <div
          class="col-3"
          [class.has-error]="hasError('settlementDate')"
        >
          <label
            >Data de Liquidação<fa-icon
              *ngIf="model.isManualSettlementDate"
              [icon]="faInfoCircle"
              title="Este fundo não possuí liquidez e, por isso, a data será preenchida manualmente pelo Administrador Fiduciário,
                   de acordo com o regulamento e a operação será liquidada na data preenchida."
            ></fa-icon
          ></label>
          <input
            type="text"
            class="form-control"
            data-cy="settlementDate"
            name="settlementDate"
            [(ngModel)]="model.settlementDate"
            [disabled]="manualsettlementDateIsDisabled"
            [required]="model.isNewFund"
            [textMask]="{ mask: validator.dateMask, guide: false }"
          />
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-1" *ngIf="false">
          <label for="FIDC">FIDC</label>
          <div>
            <div class="form-check form-check-inline">
              <input
                data-cy="isFIDC"
                class="form-check-input"
                id="FIDC"
                name="FIDC"
                [(ngModel)]="model.isFIDC"
                type="checkbox"
                (change)="cleanClassSeries()"
              />
            </div>
          </div>
        </div>
        <!--<div class="col-3">
          <label *ngIf="model.isFIDC">Classe e Série</label>
          <input
            data-cy="fundClassSeries"
            *ngIf="model.isFIDC"
            type="text"
            class="form-control"
            name="fundClassSeries"
            [(ngModel)]="model.fundClassSeries"
            maxlength="30"
            [required]="model.isFIDC"
          />
        </div>!-->
      </div>
    </div>
  </div>

  <br />

  <app-fiduci-proof
    #settlementDate
    *ngIf="model.isManualSettlementDate && model.statusDescription != null"
    [ticketId]="model.id"
    [statusDescription]="model.statusDescription"
    [isManualSettlementDate]="model.isManualSettlementDate"
    [settlementDate]="model.settlementDate"
    (tempSettlementDate)="setTempSettlementDate($event)"
  ></app-fiduci-proof>

  <app-annotation #annotation [annotation]="model.annotations"></app-annotation>

  <app-attachment
    #attachment
    [ticketId]="model.id"
    [canEdit]="canEdit()"
    [canChangeStatus]="canChangeStatus()"
    [statusDescription]="model.statusDescription"
    (tempTicketId)="setTempId($event)"
  ></app-attachment>
  <br />

  <div class="actions" *ngIf="canEdit()">
    <input
      type="button"
      value="Salvar"
      class="btn btn-primary me-2"
      [disabled]="!canEdit()"
      appDebounceClick
      (debounceClick)="submit()"
      [debounceTime]="200"
      data-cy="submit"
    />
    <input
      type="button"
      value="Encaminhar"
      class="btn btn-primary me-2"
      [disabled]="!canEdit()"
      appDebounceClick
      (debounceClick)="forward()"
      [debounceTime]="200"
      data-cy="forward"
    />
    <input
      type="button"
      value="Cancelar"
      class="btn btn-danger me-2"
      [disabled]="!canCancel()"
      appDebounceClick
      (debounceClick)="cancel()"
      [debounceTime]="200"
      data-cy="cancel"
    />
  </div>

  <div class="actions" *ngIf="canChangeStatus()">
    <input
      type="button"
      value="Aprovar"
      class="btn btn-success me-2"
      appDebounceClick
      (debounceClick)="approve()"
      [debounceTime]="200"
      data-cy="approve"
    />
    <input
      type="button"
      value="Reprovar"
      class="btn btn-danger me-2"
      appDebounceClick
      (debounceClick)="reject()"
      [debounceTime]="200"
      data-cy="reject"
    />
  </div>

  <div class="actions" *ngIf="canDuplicate()">
    <input
      type="button"
      value="Duplicar"
      class="btn btn-primary me-2"
      [disabled]="!model.id"
      appDebounceClick
      (debounceClick)="duplicate()"
      [debounceTime]="200"
      data-cy="duplicate"
    />
  </div>
</form>

<app-workflow-history
  [ticketId]="model.id"
  [refresh]="dataChanged"
></app-workflow-history>
